// extracted by mini-css-extract-plugin
export default {"page":"O0mqc","toolbar":"JZbCe","actions":"VAcrv","action":"cEKAm","text":"NdEB1"};